/**
 * Auth store con Zustand. Persistimos el access token en sessionStorage para
 * sobrevivir refresh de página pero NO entre pestañas. La cookie de refresh
 * vive en httpOnly y el refresh genera un nuevo access al boot.
 */
import { create } from "zustand";

export type Me = {
  id: string;
  tenant_id: string | null;
  email: string;
  role: "superadmin" | "tenant_admin" | "agent" | "customer";
  full_name: string;
  avatar_url: string | null;
  tenant_status: "active" | "muted" | "suspended" | "deleted" | null;
};

type AuthState = {
  accessToken: string | null;
  me: Me | null;
  setAccessToken: (t: string | null) => void;
  setMe: (m: Me | null) => void;
  logout: () => void;
};

const KEY = "datasup_access";

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: typeof sessionStorage !== "undefined" ? sessionStorage.getItem(KEY) : null,
  me: null,
  setAccessToken: (t) => {
    if (t) sessionStorage.setItem(KEY, t);
    else sessionStorage.removeItem(KEY);
    set({ accessToken: t });
  },
  setMe: (m) => set({ me: m }),
  logout: () => {
    sessionStorage.removeItem(KEY);
    set({ accessToken: null, me: null });
  },
}));
